/**
 * Notes typed API (Phase 7 reference consumer). Every shape — input body, path
 * params, resolved value — derives from the SERVER's route defs via the
 * type-only import below (erased at build; no server code reaches the bundle).
 * A server-side shape change breaks this file and its callers at compile time.
 *
 * The method/path values are restated on the line adjacent to the def reference
 * (values can't cross a type-only import); a later slice can generate this file.
 */
import { typedRoute } from "@d12labs/client";
import type { notesRouteDefs } from "../server/routes";

export const notesApi = {
	list: typedRoute<typeof notesRouteDefs.list>()("GET", "/api/plugins/notes/items"),
	create: typedRoute<typeof notesRouteDefs.create>()("POST", "/api/plugins/notes/items"),
	update: typedRoute<typeof notesRouteDefs.update>()("PATCH", "/api/plugins/notes/items/:id"),
	remove: typedRoute<typeof notesRouteDefs.remove>()("DELETE", "/api/plugins/notes/items/:id"),
};

/** The server's note row shape, derived — never redeclared by hand. */
export type NoteItem = Awaited<ReturnType<typeof notesApi.list>>[number];
